// Lightweight event tracking that mirrors one lead across the trackers loaded
// in `~/components/analytics`. Off the live hosts, every call is a harmless no-op.

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
    gtag?: (...args: unknown[]) => void;
    dataLayer?: Record<string, unknown>[];
  }
}

/** How the user headed to the app store. */
export type AppDownloadMethod = 'qr' | 'mobile' | 'ios' | 'android';

/** Fires the app-download lead across Meta Pixel, GA4, and GTM. */
export function trackAppDownloadLead(method: AppDownloadMethod) {
  if (typeof window === 'undefined') return;
  const params = { content_name: 'app_download', method };
  window.fbq?.('track', 'Lead', params);
  window.gtag?.('event', 'generate_lead', params);
  window.dataLayer?.push({ event: 'app_download_lead', ...params });
}
